<template>
  <div class="checkout-product">
    <div class="checkout-product-image-wrapper">
      <!--      <img class="checkout-product-image" src="/assets/images/product/1.jpg">-->
      <img class="checkout-product-image" :src="product.detailImageSrc">
    </div>

    <div class="checkout-product-info">
      <div class="checkout-product-row">
        <a :href="product.detailPageUrl" class="checkout-product-title" v-html="product.name"></a>
        <div class="checkout-product-price">{{ Price.format(product.price.roundedPrice) }} Р</div>
      </div>
      <div class="checkout-product-row">
        <div class="checkout-product-action-list">


          <div class="checkout-basket-control checkout-product-action --basket">
            <div class="checkout-basket-control-minus" @click="minus(product.id,parseInt(product.basketInfo.quantity)-1)">
              <img src="/assets/images/checkout/minus.svg">
            </div>
            <div class="checkout-basket-control-count">{{ product.basket_count }}</div>
            <div class="checkout-basket-control-plus" @click="plus(product.id,parseInt(product.basketInfo.quantity)+1)">
              <img src="/assets/images/checkout/plus.svg">
            </div>
          </div>

          <div :class="`checkout-product-action --favorite ${this.favorite[product.id] ? 'isActive':''}`" @click="doFavorite(product.id)">
            <div class="checkout-favorite-label" v-if="this.favorite[product.id]">В избранном</div>
            <div class="checkout-favorite-label" v-else>В избранное</div>
            <div class="checkout-favorite-icon-wrapper">
              <img class="checkout-favorite-icon" v-if="this.favorite[product.id]" src="/assets/images/checkout/favorite-orange.svg">
              <img class="checkout-favorite-icon" v-else src="/assets/images/checkout/favorite.svg">
            </div>
          </div>

          <div class="checkout-product-action --remove" @click="remove(product.id)">
            <div class="checkout-remove-label">Удалить</div>
            <div class="checkout-remove-icon-wrapper"><img class="checkout-basket-control-remove-icon" src="/assets/images/checkout/remove.svg"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Price from "../../../tool/Price";

export default {
  computed: {
    Price() {
      return Price
    }
  },
  props: {
    favorite: Object,
    product: Object,
  },
  name: "CheckoutProduct",
  methods: {
    plus(productId, count) {
      this.$parent.plus(productId, count);
    },
    minus(productId, count) {
      this.$parent.plus(productId, count);
    },
    doFavorite(productId) {
      this.$parent.favorite(productId);
    },
    remove(productId) {
      this.$parent.remove(productId);
    },
  },
}
</script>

<style scoped>

</style>
